import { store, persistor } from "../redux/store";
import { resetAuth } from "../redux/slices/authSlice";

const AUTH_ERROR_SESSION_KEY = "microlab_auth_error";

/**
 * Global logout helper for the web app (micro-web).
 * - Clears persisted Redux auth/general state
 * - Clears the legacy "token" from localStorage
 * - Redirects to the sign-in route so all roles and routes are reset
 * @param {string} [message] - Optional message shown on sign-in (e.g. session invalid / university access).
 */
export function performLogout(message) {
  if (message && typeof message === "string") {
    try {
      sessionStorage.setItem(AUTH_ERROR_SESSION_KEY, message);
    } catch (e) {
      // non-fatal
    }
  }

  try {
    // Wipe persisted Redux state (whitelisted slices in persistConfig)
    persistor.purge();
  } catch (e) {
    // non-fatal
  }

  try {
    store.dispatch(resetAuth());
  } catch (e) {
    // non-fatal
  }

  try {
    localStorage.removeItem("token");
  } catch (e) {
    // non-fatal
  }

  // Hard redirect so all React state & routes reset to login
  window.location.href = "/authentication/sign-in";
}

export { AUTH_ERROR_SESSION_KEY };

